import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-pagnation',
  templateUrl: './pagnation.component.html',
  styleUrls: ['./pagnation.component.css']
})
export class PagnationComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Output() callback: EventEmitter<any> = new EventEmitter();

  page_arr: number[] = [];
  page_count: number = 0;

  // 顯示給 input 用（1-based）
  input_tmp_page: number = 1;

  constructor() {}

  ngOnInit(): void {
    // ✅ 初始化只更新 UI，不要 emit，避免父層再打一次 API
    this.recalc();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      // ✅ Input 更新只更新 UI，不要 emit
      this.recalc();
    }
  }

  /**
   * ✅ 只負責計算 page_count / page_arr / input_tmp_page
   * ❌ 不要在這裡改 this.data.page（Input 只讀），也不要 emit
   */
  private recalc(): void {
    if (!this.data) return;
    if (typeof this.data.total_count === 'undefined') return;

    const total = Number(this.data.total_count ?? 0);
    const count = Number(this.data.count ?? 0);

    if (!count || count <= 0) {
      this.page_count = 0;
      this.page_arr = [];
      this.input_tmp_page = 1;
      return;
    }

    this.page_count = Math.ceil(total / count);

    const page = Number(this.data.page ?? 0);
    const safePage = Math.min(Math.max(page, 0), Math.max(this.page_count - 1, 0));

    // 原本邏輯：顯示前後各 3 頁
    let start = safePage < 3 ? 0 : safePage - 3;
    let end = safePage + 3;

    if (end > this.page_count) end = this.page_count;

    const arr: number[] = [];
    for (let i = start; i < end; i++) arr.push(i);
    this.page_arr = arr;

    // input 顯示 1-based
    this.input_tmp_page = safePage + 1;
  }

  /**
   * ✅ 只有使用者操作才 emit
   * ✅ emit 新物件，避免子元件直接改到父層傳進來的 reference
   */
  private emitPage(page: number): void {
    if (!this.data) return;
    if (isNaN(page)) return;

    // 如果還沒計算出 page_count，就先算
    if (!this.page_count) this.recalc();

    const safePage = Math.min(Math.max(page, 0), Math.max(this.page_count - 1, 0));

    // ✅ 不要 this.data.page = safePage（會改到父層）
    this.callback.emit({ ...this.data, page: safePage });

    // 更新 UI
    this.recalc();
  }

  click_page(page: number): void {
    this.emitPage(page);
  }

  pre_click_page(): void {
    const cur = Number(this.data?.page ?? 0);
    this.emitPage(cur - 1);
  }

  aft_click_page(): void {
    const cur = Number(this.data?.page ?? 0);
    this.emitPage(cur + 1);
  }

  inputpage(): void {
    if (!this.page_count) this.recalc();
    if (!this.page_count) return;

    let p = Number(this.input_tmp_page);
    if (isNaN(p)) return;

    p = p < 1 ? 1 : p > this.page_count ? this.page_count : p;
    this.emitPage(p - 1);
  }

  getstyle(): any {
    const width = this.page_count.toString().length * 60;
    return {
      width: width + 'px',
      display: 'inline',
      'margin-left': '5px',
      height: '36px'
    };
  }
}
